import React from "react";
import { UpdateLocalBasicInfoDTO } from "../../../../models/local/local.request";

interface BasicInfoTabProps {
    value: UpdateLocalBasicInfoDTO;
    onChange: (value: UpdateLocalBasicInfoDTO) => void;
}

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ value, onChange }) => {
    return (
        <div className="admin-settings-box-div basic-info-block">
            <div className="list-header-info">
                <div className="list-header-title">Osnovni podaci</div>
                <div className="list-header-description">
                    Ovi podaci se prikazuju gostima u meniju<br />
                </div>
            </div>
            <div className="info-settings-div">
                <div className="w-form">
                    <form className="form-4">

                        <div className="div-block-5">
                            <label >Naziv lokala</label>
                            <input className="form-input basic-info w-input" placeholder="Unesite naziv lokala" type="text"
                                value={value.name}
                                onChange={(e) => onChange({ ...value, name: e.target.value })}
                            />
                        </div>

                        <div className="div-block-5">
                            <label >Opis</label>
                            <textarea placeholder="Unesite opis lokala &#10;(npr. Tradicionalni restoran sa autentičnom kuskom i prijatnom atmosferom. Specijalizovani smo za ribu i morske specijalitete. Posedujemo veliku vinarsku kolekciju i stručno osoblje.)" className="form-textarea grey w-input"
                                value={value.description}
                                onChange={(e) => onChange({ ...value, description: e.target.value })}
                            ></textarea>
                        </div>

                        <div className="div-block-5">
                            <label>Radno vreme</label>
                            <textarea className="form-textarea grey w-input" placeholder="Unesite radno vreme lokala &#10;Ponedeljak - Subota: 10:00-22:00&#10;Nedelja: 11:00-18:00" 
                                value={value.workingHours}
                                onChange={(e) => onChange({ ...value, workingHours: e.target.value })}
                            ></textarea>
                        </div>

                        <div className="div-block-6">

                            <div className="div-block-5">
                                <label >WiFi ime</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite wifi ime (npr. Restoran zlatna ladja 5G)" type="text"
                                    value={value.wifiName}
                                    onChange={(e) => onChange({ ...value, wifiName: e.target.value })}
                                />
                            </div>

                            <div className="div-block-5">
                                <label >WiFi lozinka</label>
                                <input className="form-input basic-info w-input" placeholder="Unesite wifi lozinku (npr. zladja123)" type="text" 
                                    value={value.wifiPassword}
                                    onChange={(e) => onChange({ ...value, wifiPassword: e.target.value })}
                                />
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    );
};

export default BasicInfoTab;